var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2a.999.999 0 1 0 0 2h2a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-2a.999.999 0 1 0 0 2Zm-.294 5.706c.39-.39.39-1.025 0-1.415l-4-4a1.002 1.002 0 0 0-1.415 1.415L11.584 11H5a.999.999 0 1 0 0 2h6.584l-2.293 2.294a1.002 1.002 0 0 0 1.415 1.415l4-4v-.003Z",
    fill: "#002FF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBlueIcon);
export default __webpack_public_path__ + "static/media/login-blue-icon.81e0e5c5a0923e7070ff186df8609891.svg";
export { ForwardRef as ReactComponent };